import { Control, ControlType } from './control';

export class PasswordControl extends Control<string> {
  constructor(name: string, placeholder: string) {
    super(name, placeholder, ControlType.password, '');
  }
}
